import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Logout() {
  const [open, setOpen] = React.useState(true);
  const navigate = useNavigate();
  const cookies = new Cookies();

  const handleCancel = () => {
    setOpen(false);
    navigate('../');
  };

  const handleAccept = () => {
    cookies.remove('umf_user', { path: '/' });
    navigate('/login', { replace: true });
  };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCancel}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{'Logout?'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">Are you sure you want to logout?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button onClick={handleAccept}>Yes</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
